import type { AxiosResponse } from 'axios';

import { request } from '../requestService';

import { type IAuditRequest, type IAuditResponse, type IDocumentHistoryResponse } from '../../store/audit/types';

const ENDPOINTS = {
  audit: 'audit',
  versions: 'versions',
  difference: 'difference',
};

export function getDocumentHistory(documentId: string): Promise<AxiosResponse<IDocumentHistoryResponse>> {
  return request({
    url: `${ENDPOINTS.audit}/${ENDPOINTS.versions}/${documentId}`,
  });
}

export function getVersionComparison({
  documentId,
  leftEpochMillis,
  rightEpochMillis,
}: IAuditRequest): Promise<AxiosResponse<IAuditResponse>> {
  return request({
    url: `${ENDPOINTS.audit}/${ENDPOINTS.difference}/${documentId}/${leftEpochMillis}/${rightEpochMillis}`,
  });
}
